export default "__VITE_ASSET__DCECKNrA__"